import { render, staticRenderFns } from "./CommunitySideNavItems.vue?vue&type=template&id=447553f0&scoped=true&"
import script from "./CommunitySideNavItems.vue?vue&type=script&lang=js&"
export * from "./CommunitySideNavItems.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySideNavItems.vue?vue&type=style&index=0&id=447553f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447553f0",
  null
  
)

export default component.exports